module.exports = __webpack_public_path__ + "img/huanghuanganggongyuan.2dd14c3a.png";